import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueI18n from 'vue-i18n';

import { languages } from './i18n/translations';
import { defaultLocale } from './i18n/translations';
import { auth } from './firebaseConfig';

import wrap from '@vue/web-component-wrapper';
import TestComponent from './views/TestComponent';
import '@/assets/style/main.scss';

const messages = Object.assign(languages);

Vue.config.productionTip = false;

Vue.use(VueI18n);

const language = navigator.language.substring(0, 2);

const i18n = new VueI18n({
  locale: language,
  fallbackLocale: defaultLocale,
  messages: messages,
});

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

var mount = '#app';
if (params.mount) {
  mount = '#' + params.mount;
} else if (document.documentElement.getAttribute('ondago_webviewer_mount')) {
  mount = '#' + document.documentElement.getAttribute('ondago_webviewer_mount');
}

let app;
auth.onAuthStateChanged(() => {
  if (!app) {
    new Vue({
      i18n,
      router,
      store,
      render: (h) => h(App),
    }).$mount(mount);
  }
});

Vue.mixin({
  data: function () {
    return {
      get bootstrap() {
        return window.bootstrap;
      },
    };
  },
});

// new Vue({
//     i18n,
//     router,
//     store,
//     render: h => h(App)
// }).$mount('#app')

const customElement = wrap(Vue, TestComponent);
window.customElements.define('my-custom-element', customElement);
